import { Text } from "@mantine/core";

import {
  formatDate,
  formatNZD,
  getLocalDateString,
  transformRef,
} from "common/utils";
import PreviewHeader from "components/header/PreviewHeader";
import React, { useState } from "react";
import { AgedTrialBalance } from "types/model.types";

interface IAdminStatementViewProps {
  data: AgedTrialBalance;
}

const AdminStatementView: React.FC<IAdminStatementViewProps> = ({ data }) => {
  const [exporting, setExporting] = useState(false);
  let runningBalance = 0;

  return (
    <>
      <PreviewHeader />
      <div className="sub-title">STATEMENT</div>

      <div className="divider padBottom" />

      <table className="print-table">
        <tbody>
          <tr className="vat">
            <td>
              <div>{data?.surname}</div>
              <div>{data?.addressLine1}</div>
              <div>{data?.addressLine2}</div>
              <div>{data?.addressLine3}</div>
            </td>
            <td>
              <span className="bold">Statement Date: </span>
              <br />
              <span>{formatDate(data?.createdOn ?? getLocalDateString())}</span>
            </td>
          </tr>
          <tr className="vat">
            <td>
              <br />
              <span className="bold">Account Code: </span>
              <span>{data?.id}</span>
            </td>
            <td>
              <br />
              <span className="bold">Customer: </span>
              <span>{data?.surname}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="spacer paddTop padBottom" />

      {/* Render logic for orderDetails array here */}
      <table className="print-table details-table">
        <thead>
          <tr>
            <th className="nowrap">Date</th>
            <th className="nowrap">Type</th>
            <th className="nowrap">Ref</th>
            <th className="money">Debit</th>
            <th className="money">Credit</th>
            <th className="money">Balance</th>
          </tr>
        </thead>
        <tbody>
          {data?.transactions.map((transaction, index) => {
            const debit = transaction.debit ?? 0;
            const credit = transaction.credit ?? 0;
            // Update running balance
            if (debit > 0) {
              runningBalance += debit;
            }
            if (credit > 0) {
              runningBalance -= credit;
            }
            if (runningBalance < 0 && Math.abs(runningBalance) < 0.0000001) {
              runningBalance = 0;
            }

            return (
              <tr key={index}>
                <td className="nowrap">{formatDate(transaction.createdOn)}</td>
                <td className="nowrap">{transaction.type2}</td>
                <td className="nowrap">{transformRef(transaction.ref)}</td>
                <td className="money">{formatNZD(transaction.debit)}</td>
                <td className="money">{formatNZD(transaction.credit)}</td>
                <td className="money">{formatNZD(runningBalance)}</td>
              </tr>
            );
          })}
          <tr>
            <td colSpan={2}></td>
            <td colSpan={4}>
              <table className="print-table">
                <thead>
                  <tr>
                    <th className="money">90+ Days</th>
                    <th className="money">60 Days</th>
                    <th className="money">30 Days</th>
                    <th className="money">Current</th>
                    <th className="money">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="money-focal">
                    <td className="money">{formatNZD(data?.month3 ?? 0)}</td>
                    <td className="money">{formatNZD(data?.month2 ?? 0)}</td>
                    <td className="money">{formatNZD(data?.month1 ?? 0)}</td>
                    <td className="money">
                      {formatNZD(data?.currentMonth ?? 0)}
                    </td>
                    <td className="money">{formatNZD(data?.balance)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr className="money-focal">
            <td colSpan={4} align="right">
              <Text fw={700} ta={"right"}>
                Closing Balance:
              </Text>
            </td>
            <td colSpan={2} className="money">
              {formatNZD(runningBalance)}
            </td>
          </tr>
          <tr>
            <td className="disclaimer" colSpan={6}>
              <br />
              NOTE: THE GOODS SHOWN ON THIS INVOICE WILL CONTINUE TO REMAIN THE
              PROPERTY OF JOHN JACOBSON LTD UNTIL THIS INVOICE HAS BEEN PAID IN
              FULL
            </td>
          </tr>
          <tr>
            <td colSpan={6}>
              Direct Credit payments can be made to: <br />
              Westpac, Petone, Account <em>03-0543-0207702-00</em>
            </td>
          </tr>
          <tr>
            <td colSpan={6}>
              Printed on: {formatDate(new Date().toDateString())}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
export default AdminStatementView;
